module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"desktop":"Desktop","mobile":"Mobile","mode":"Frequency","daily":"Daily","weekly":"Weekly"},"fr":{"desktop":"Bureau","mobile":"Mobile","mode":"Périodicité","daily":"Journalier","weekly":"Hebdomadaire"},"de":{"desktop":"Büro","mobile":"Handy, Mobiltelefon","mode":"Periodizität","daily":"Täglich","weekly":"Wöchentlich"}}')
  delete Component.options._Ctor
}
